import { Component, OnInit } from '@angular/core';
import { InactiveTimerService } from '../../../../services/inactive-timer.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';


@Component({
  selector: 'app-partner-page',
  templateUrl: './partner.page.html',
  styleUrls: ['./partner.page.css']
})
export class PartnerPageComponent implements OnInit {

  constructor(
    private inactiveTimerService: InactiveTimerService,
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  ngOnInit(): void {
    if (!this.shopSettingsService.isVUMode
      && this.shopSettingsService.shopSettings
      && !this.shopSettingsService.shopSettings.logoutByTimeout) {
      this.inactiveTimerService.clearTimer();
    }
  }
}
